import { render, staticRenderFns } from "./MbLoading.vue?vue&type=template&id=7e0bc8c4&scoped=true&"
import script from "./MbLoading.vue?vue&type=script&lang=js&"
export * from "./MbLoading.vue?vue&type=script&lang=js&"
import style0 from "./MbLoading.vue?vue&type=style&index=0&id=7e0bc8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0bc8c4",
  null
  
)

export default component.exports